document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".scroll-word-container");
  if (!container) return;

  const words = container.querySelectorAll(".scroll-word");
  if (words.length < 2) {
    if (words.length === 1) words[0].classList.add("active");
    return;
  }

  const holdTime = parseInt(container.dataset.autoplay, 10) || 3000;
  const transitionTime = 600; // must match CSS

  let index = 0;
  words[0].classList.add("active");

  function showNextWord() {
    const current = words[index];
    const nextIndex = (index + 1) % words.length;
    const next = words[nextIndex];

    current.classList.remove("active");
    current.classList.add("exit");
    next.classList.add("active");

    setTimeout(() => current.classList.remove("exit"), transitionTime);
    index = nextIndex;
  }

  setInterval(showNextWord, holdTime + transitionTime);
});
